import { AiFillFileAdd } from 'react-icons/ai'
import { useNavigate } from 'react-router-dom'
import { Flex, Flexed,Fixed,Input,List, Button } from '../../Shared'
import axios from 'axios'
import { useState,useEffect } from 'react'
import Moment from 'react-moment'
import {sortcustomername, sortdate, sortit, sortjobname, sortjobnum, sortnum, sortpo} from '../../Util/Sort'
import PrintComponent from '../../print/Quoteletter'





const Quotes = () => {

const [quotes, setQuotes] = useState([])
const [search, setSearch] = useState("")
const [order, setOrder] = useState("ASC")
useEffect(() => {
const getAllJobs = async() => {
   // await axios.get(`.https://cfpapi-6ab062006fa0.herokuapp.com/quotes/getopenquotes`)
    await axios.get(`https://cfpapi-6ab062006fa0.herokuapp.com/quotes/getopenquotes`)
    .then( res => setQuotes(res.data))
    .catch(err => console.log(err))
}
getAllJobs()
},[])


console.log(quotes)

    const nav = useNavigate()
  return (
<>
    <div style={{padding:"0px 20px",position:"relative"}}>

<Flexed padding="25px 0px 0px 0px">
  <Flex>CFP Quotes</Flex>
  <Flex><Button style={{background:'#0E425A',color:'white'}} onClick={e => nav('/estimate')}>New Quote</Button></Flex>
</Flexed>
<Flexed padding="25px 0px 0px 0px">
  <Flex><Input type="text" height="30px" placeholder="Search Quotes       For dates use format 2025-01-02" onChange={e => setSearch(e.target.value)}/></Flex>
</Flexed>
<Flexed bgColor="#4EC0AC" borderBottom="1px solid black" margin="40px 0px 0px 0px">
   <Flex onClick={e => sortnum('quotenum',order,quotes,setQuotes,setOrder)}>Quote #</Flex>
   <Flex flex="2" onClick={e => sortcustomername('',order,quotes,setQuotes,setOrder)}>Customer</Flex>
   <Flex flex="2" onClick={e => sortjobname('',order,quotes,setQuotes,setOrder)}>Job Name</Flex>
   <Flex flex="2" onClick={e => sortpo('',order,quotes,setQuotes,setOrder)}>Cust P.O. #</Flex>
  <Flex onClick={e => sortdate('createdAt',order,quotes,setQuotes,setOrder)}>Enter Date</Flex>
  <Flex onClick={e => sortdate('duedate',order,quotes,setQuotes,setOrder)}>Due Date</Flex>
  <Flex>Status</Flex>

    <Flex></Flex>
</Flexed>


{
    quotes?.filter(item => {
        if (search === "") return true;

        const term = search.toLowerCase();

        return (
            (item.quotenum?.toString() || "").includes(term) ||
            (item?.customer?.name || "").toLowerCase().includes(term) ||
            (item?.jobName || "").toLowerCase().includes(term) ||
            (item?.customerPO || "").toLowerCase().includes(term) ||
            (item?.customerJobNumber || "").toLowerCase().includes(term) ||
            (item?.createdAt ? new Date(item.createdAt).toISOString().slice(0,10).includes(term) : false) ||
            (item?.dueDate ? new Date(item.dueDate).toISOString().slice(0,10).includes(term) : false) ||
            (item?.status <= 0 ? "open" : "closed").includes(term)
        );
    }).map(quote => (
        <Flexed padding="6px 0px" key={quote._id}>
            <Flex className="hand" onClick={() => nav('/estimate/' + quote._id)}>{quote.quotenum}</Flex>
            <Flex flex="2">{quote?.customer?.name}</Flex>
            <Flex flex="2">{quote?.jobName}</Flex>
            <Flex flex="2">{quote?.customerPO}</Flex>
            <Flex><Moment format="MM/DD/YYYY">{quote?.createdAt}</Moment></Flex>
            <Flex><Moment format="MM/DD/YYYY">{quote?.dueDate}</Moment></Flex>
            <Flex>{quote?.status <= 0 ? "Open" : "Closed"}</Flex>
           
            <Flex><PrintComponent quote={quote} /></Flex>
        </Flexed>
    ))
}
{/* {

    quotes?.filter(item => {return search.toLowerCase() === '' ? item : item.quotenum.toString().includes(search) || item?.customer?.name.toLowerCase().includes(search.toLowerCase()) || item?.info?.jobname.toLowerCase().includes(search.toLowerCase()) || item?.info?.custjobnum?.toString().includes(search.toLowerCase()) || item?.info?.custponum?.toString().includes(search.toLowerCase()) || item?.createdAt.toLowerCase().includes(search.toLowerCase()) || item?.duedate.toLowerCase().includes(search.toLowerCase())}).map(quote => {
return<Flexed padding="6px 0px">
   <Flex className="hand" onClick={e => nav('/estimate/'+quote._id)}>{quote.quotenum}</Flex>
   <Flex flex="2">{quote?.customer?.name}</Flex>
   <Flex flex="2">{quote?.jobName}</Flex>
   <Flex >{quote?.customerPO}</Flex>
   <Flex ></Flex>
  <Flex><Moment format="MM/DD/YYYY">{quote?.createdAt}</Moment></Flex>
  <Flex><Moment format="MM/DD/YYYY">{quote?.dueDate}</Moment></Flex>
  <Flex>{quote?.status <= 0 ? "Open" : "Closed"}</Flex>
  <Flex flex='.1'></Flex>
   <Flex><PrintComponent  quote={quote}  /></Flex>
</Flexed>


    })
  } */}

</div>
</>
  )
}

export default Quotes